import React, { useRef, useState, useEffect } from "react";
import moment from "moment";
import useCrypto from "../../../customHooks/crypto";
import DefaultImage from "../../../../assets/images/default-icon.png";
import { useSelector } from "react-redux";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import useLangTranslation from "../../../customHooks/languageProvider";
import useSubscription from "../../../customHooks/subscriptionProvider";
import io from "socket.io-client";
import Box from "@mui/material/Box";
import {
  getConversation as getConversationService,
  readMessages as readMsgService,
  messageCount as messageCountService,
} from "../../AxiosRtk/Messages";
import { getPreSignedUrl, uploadFileToS3 } from "../../AxiosRtk/Miscellaneous";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import TakePhotoModal from "../modals/TakePhotoModal";
import ChatPhotoPreviewModal from "../modals/ChatPhotoPreviewModal";
import { CircularProgress } from "@mui/material";
import ViewPictureMessages from "../modals/ViewPictureMessages";

const MessageMyChild = () => {
  const bottomRef = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const { encodeNumberToBase64 } = useCrypto();
  const [imageUrl, setImageUrl] = useState("");
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [takePhotoModal, setTakePhotoModal] = useState({
    show: false,
    data: "",
  });
  const [filteredKidList, setFilteredKeyList] = useState([]);
  const { getImage } = useKidListFunctionality();
  const [deviceData, setDeviceData] = useState(null);
  const [chatSelectKid, setChatSelectKid] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [socket, setSocket] = useState(null);
  const { getLangTranslation } = useLangTranslation();
  const [typedMsg, setTypedMsg] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [presignedData, setPresignedData] = useState("");
  const [image, setImage] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [viewPictureModal, setViewPictureModal] = useState(false);

  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  function getDeviceStatus(status) {
    if (status === "Online") {
      return "success";
    } else if (status === "Offline") {
      return "danger";
    } else if (status === "Idle") {
      return "warning";
    } else {
      return "";
    }
  }
  const { checkSubsciption } = useSubscription();
  useEffect(() => {
    if (location?.state?.kidName) {
      setChatSelectKid(location?.state?.kidName);
    } else {
      const selectedKidData = kidList?.find(
        (item) => item?.ID === selectedKidId
      );
      setChatSelectKid(selectedKidData);
    }
  }, [kidList]);
  useEffect(() => {
    if (selectedDeviceData) {
      // const deviceJson = selectedDeviceData
      //   ? JSON.parse(selectedDeviceData?.ID)
      //   : null;
      // const kidDeviceData = kidDevicesList?.find(
      //   (item) => item?.ID === parseInt(selectedDeviceData?.ID)
      // );
      setDeviceData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const messagesEndRef = useRef(null);
  const getConversation = async (roomId) => {
    try {
      const { data } = await getConversationService({ roomId });
      if (data) {
        setConversation(data?.result);
        if (data?.result?.length > 0) {
          updateReadMesage(data?.result);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchSlotData = async () => {
    const req = {
      kidId: chatSelectKid?.ID,
      parentId: chatSelectKid?.parentID,
    };
    try {
      const { data } = await messageCountService(req);
    } catch (error) {
      console.log(error);
    }
  };

  const updateReadMesage = async (update) => {
    if (update) {
      const ids = update?.map((item) => item.messageId);
      const req = {
        type: 1,
        id: ids,
        isKidRead: 0,
      };
      try {
        const { data } = await readMsgService(req);
        if (data) {
          fetchSlotData();
        }
      } catch (error) {
        // alert.error(error?.response?.data?.message);
        console.log(error);
      }
    }
  };

  const connectToRoom = () => {
    const req = {
      userId: chatSelectKid?.parentID,
      kidId: chatSelectKid?.ID,
      userType: 1,
    };
    try {
      socket.emit("create-room", req);

      socket.on("room-id-response", (data) => {
        setRoomId(data?.roomId);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const CONNECTION_PORT = process.env.REACT_APP_CONNECTION_PORT_NEW;
    setSocket(io(CONNECTION_PORT));
  }, []);

  useEffect(() => {
    if (socket && chatSelectKid) {
      connectToRoom();
    }
  }, [chatSelectKid]);

  useEffect(() => {
    if (roomId) {
      getConversation(roomId);
      const interval = setInterval(() => getConversation(roomId), 30000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [roomId]);

  function handleMessageSubmit() {
    if (!checkSubsciption()) {
      return;
    } else {
      const req = {
        userId: chatSelectKid?.parentID,
        roomId: roomId,
        message: imageUrl ? imageUrl : typedMsg,
        userType: 1,
        type: imageUrl ? 2 : 1,
      };
      socket.emit("add-message", req);
      socket.on("add-message-response", (data) => {
        if (data) {
          setTimeout(getConversation(roomId), 10000);
          setImageUrl("");
          setImagePreviewModal(false);
        }
      });

      setTypedMsg("");
      // }
    }
  }
  function handleKeyPress(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      // Prevent default behavior of Enter key
      event.preventDefault();
      // Call the submit function if Enter is pressed without Shift
      handleMessageSubmit();
    }
  }

  function handleInputChange(e) {
    setTypedMsg(e.target.value);
  }

  const handleImageUpload = async (event) => {
    if (!checkSubsciption()) {
      return;
    } else {
      setImageLoading(true);
      const payload = {
        type: "put",
        fileName: `${encodeNumberToBase64(chatSelectKid?.parentID)}/ChatPics/${event.target.files[0].name
          }`,
      };
      try {
        getPreSignedUrl(payload)
          .then((res) => {
            console.log("data of presigned url", res);
            setPresignedData(res?.data?.result);
          })
          .catch((err) => {
            console.log(
              "catch error presigned url ==>>",
              err?.response?.data?.message
            );
          });
      } catch (error) {
        console.log(error);
      }
      setImage({ file: event.target.files[0] });
    }
  };

  const handleClickedImageUpload = (file) => {
    // new image upload code start-------------------------------------------------------------
    // debugger

    if (!checkSubsciption()) {
      // AlertModal(getLangTranslation('your_subscription_is_expired'), alertIconType?.infoIcon, true);
      return;
    } else {
      setImageLoading(true);
      const payload = {
        type: "put",
        fileName: `${encodeNumberToBase64(chatSelectKid?.parentID)}/ChatPics/${file.name
          }`,
      };
      try {
        getPreSignedUrl(payload)
          .then((res) => {
            setPresignedData(res?.data?.result);
          })
          .catch((err) => {
            console.log(
              "catch error presigned url ==>>",
              err?.response?.data?.message
            );
          });
      } catch (error) {
        console.log(error);
      }

      // new image upload code end-------------------------------------------------------------
      setImage({ file: file });
    }
  };

  useEffect(() => {
    if (presignedData) {
      uploadFileToS3(`${presignedData?.signedUrlForPutObject}`, image?.file, {
        "Content-Type": image?.file.type,
        version_code: 20000,
      })
        .then((res) => {
          const message = `${image?.file?.name}`;

          // setTypedMsg(message);
          //   handleMessageSubmit(message);
          setImageUrl(message);
          setImageLoading(false);
          setImagePreviewModal(true);
        })
        .catch((error) => {
          console.log(
            "upload to s3 catch error ==>>",
            error?.response?.data?.message
          );
          setImageLoading(false);
        });
    }
  }, [presignedData]);

  useEffect(() => {
    if (searchKey) {
      const filterData = kidList?.filter((item) =>
        item?.childName?.toLowerCase()?.includes(searchKey?.toLowerCase())
      );
      setFilteredKeyList(filterData);
      setChatSelectKid(null);
      setConversation([]);
    } else {
      setFilteredKeyList(kidList);
    }
  }, [searchKey]);

  const handleOpenTakePhotoModal = () => {
    setTakePhotoModal({ show: true, data: "" });
  };

  const openViewPicture = (url) => {
    setSelectedItem(url);
    setViewPictureModal(true);
  };

  const closeViewPicture = () => {
    setViewPictureModal(false);
  };

  const handleCloseTakePhotoModal = () => {
    setTakePhotoModal({ show: false, data: "" });
  };

  const handleCameraDoneClick = (file) => {
    handleClickedImageUpload(file);
    // setShowEditPhotoModal(true);
    setTakePhotoModal({ show: false, data: "" });
  };

  function generateImageUrl(message) {
    if (!message?.includes("ChatPics")) {
      return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW
        }/${encodeNumberToBase64(chatSelectKid?.parentID)}/ChatPics/${message}`;
    }

    return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW
      }/${encodeNumberToBase64(chatSelectKid?.parentID)}/${message}`;
  }

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation]);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);

  return (
    <>
      <TakePhotoModal
        show={takePhotoModal?.show}
        handleClose={handleCloseTakePhotoModal}
        onDone={handleCameraDoneClick}
        getLangTranslation={getLangTranslation}
      />
      <ChatPhotoPreviewModal
        show={imagePreviewModal}
        handleClose={() => {
          setImagePreviewModal(false);
          setImageUrl("");
        }}
        onDecline={() => {
          setImagePreviewModal(false);
          setImageUrl("");
        }}
        onSend={() => {
          handleMessageSubmit();
        }}
        imageUrl={generateImageUrl(imageUrl)}
        loading={imageLoading}
        getLangTranslation={getLangTranslation}
      />
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5 pt-cursor"
                  >
                    <i className={`${lang?.isRTL === 1 ? 'icon-arrow-right' : 'icon-arrow-left'}`} />
                  </div>
                  <h3 className="text-blue-900 mb-0"> {getLangTranslation("MESSAGE_TO_MY_CHILD", "Message to my child")}</h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded border-0 me-2 p-0">
                <img
                  src={getImage(chatSelectKid?.image, chatSelectKid?.gender)}
                  className="rounded-circle"
                  alt=""
                />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">
                  {chatSelectKid?.childName}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className={`card-body ${lang?.isRTL === 1 ? 'ps-6 ps-xl-0' : 'pe-6 pe-xl-0'}`}>
          <div className="message-wrap msg-my-child">
            <div className="message-right ps-xl-6  flex-fill" >
              <ul className={`message-body-wrap ${lang?.isRTL === 1 ? 'ps-xl-6 pe-0' : 'pe-xl-6'}`} ref={messagesEndRef}>
                {conversation?.map((item, i) => {
                  return (
                    <>
                      {moment(conversation[i]?.dateCreated)
                        .locale("en")
                        .format("YYYY-MMM-DD") !==
                        moment(conversation[i - 1]?.dateCreated)
                          .locale("en")
                          .format("YYYY-MMM-DD") && (
                          <li key={item?.messageId + 1}>
                            <div className="unseen-message my-4">
                              <span className="text-small text-gray text-uppercase bg-white position-relative px-6">
                                {moment(item?.dateCreated)
                                  .locale("en")
                                  .format("YYYY-MMM-DD")}
                              </span>
                            </div>
                          </li>
                        )}
                      <li key={item?.messageId + 2}>
                        {/* <div> */}
                        <div
                          className={`message-body ${item?.senderId === chatSelectKid?.parentID
                              ? "message-sent"
                              : ""
                            }`}
                        >
                          {item?.type === 2 ? (
                            <div className="chat-img-view ratio ratio-1x1">
                            <img
                              src={generateImageUrl(item?.Message)}
                              alt=""
                              height={50}
                              width={50}
                              className="pt-cursor"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = DefaultImage;
                              }}
                              onClick={() => {
                                openViewPicture(
                                  generateImageUrl(item?.Message)
                                );
                              }}
                            />
                          </div>
                          ) : (
                            <p className="mb-0 text-break">{item?.Message}</p>
                          )}
                        </div>
                        <span
                          className={`msg-time ${item?.senderId === chatSelectKid?.parentID
                              ? "text-end"
                              : "text-start"
                            }`}
                        >
                          {moment(item?.dateCreated)
                            .locale("en")
                            .format("HH:mm")}
                        </span>
                        {/* </div> */}
                      </li>
                    </>
                  );
                })}
                <div ref={bottomRef} />
              </ul>
              {/* <form onSubmit={handleMessageSubmit}> */}
              {!imageLoading && (
                <div className={`input-group ${lang?.isRTL === 1 ? 'ps-xl-6' : 'pe-xl-6'}`}>
                  <span
                    className={`input-group-text pt-cursor custom-file-wrap rounded-pill ${lang?.isRTL === 1 ? 'rounded-start border-start-0' : 'rounded-end border-end-0'}`}>
                    <i className="icon-link fs-5">
                      <input
                        type="file"
                        onChange={(e) => handleImageUpload(e)}
                      />
                    </i>
                  </span>
                  <span
                    className="input-group-text pt-cursor custom-file-wrap border-end-0"
                    onClick={handleOpenTakePhotoModal}
                  >
                    <i className="icon-camera fs-5"></i>
                  </span>
                  <textarea
                    className="form-control border-end-0 border-start-0"
                    rows="1"
                    onKeyPress={handleKeyPress}
                    onChange={handleInputChange}
                    value={typedMsg}
                  ></textarea>
                  <button
                    type="submit"
                    disabled={!imageUrl && !typedMsg}
                    className={`input-group-text rounded-pill  ${lang?.isRTL === 1 ? 'rounded-end border-end-0' : 'rounded-start border-start-0'}`}
                    onClick={handleMessageSubmit}
                  >
                    <span className="icon-wrap rounded-circle p-0 bg-blue-300 ">
                      <i className="icon-send text-white pt-cursor" />
                    </span>
                  </button>
                </div>
              )}
              {imageLoading && (
                <div className="d-flex justify-content-center">
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                </div>
              )}
              {/* </form> */}
            </div>
            {/* <div className='flex-fill'>
                        <ul className='message-body-wrap pe-xl-6'>
                            <li>
                                <div className='message-body'>
                                    <p className="mb-0 text-break">Lorem ipsum dolor sit amet consectetur. Integer mi vitae pulvinar quis consectetur nisi.</p>
                                </div>
                            </li>
                            <li>
                                <div className='message-body'>
                                    <p className="mb-0 text-break">Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li>
                                <div className='message-body message-sent'>
                                    <p className="mb-0 text-break">Lorem ipsum dolor sit amet consectetur. Tellus dolor commodo lacus pulvinar ultrices varius. Tincidunt quam at metus quam.</p>
                                </div>
                            </li>
                            <li>
                                <div className='unseen-message my-4'>
                                    <span className="text-small text-gray text-uppercase bg-white position-relative px-6">2022-Nov-01</span>
                                </div>
                            </li>
                            <li>
                                <div className='message-body'>
                                    <p className="mb-0 text-break">Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li>
                                <div className='message-body message-sent'>
                                    <p className="mb-0 text-break">Lorem ipsum dolor sit amet consectetur. Tellus dolor commodo lacus pulvinar ultrices varius. Tincidunt quam at metus quam.</p>
                                </div>
                            </li>
                        </ul>
                        <div className="input-group pe-xl-6">
                            <span className="input-group-text pt-cursor custom-file-wrap rounded-pill rounded-end border-end-0">
                                <i className='icon-link fs-5'>
                                    <input type='file' />
                                </i>
                            </span>
                            <textarea className="form-control border-end-0 border-start-0" rows='1' />
                            <span className="input-group-text rounded-pill rounded-start border-start-0">
                                <i className='icon-send icon-wrap bg-blue-300 rounded-circle text-white pt-cursor' />
                            </span>
                        </div>
                    </div> */}
          </div>
        </div>
      </div>
      <ViewPictureMessages
        showModal={viewPictureModal}
        closeModal={closeViewPicture}
        selectedItem={selectedItem}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default MessageMyChild;
